
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVolumeOn as ObiVolumeOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-volume-on.js';
 
 
 

 
 export const ObiVolumeOn = createComponent({
   react: React,
   tagName: 'obi-volume-on',
   elementClass: ObiVolumeOnElement,
   events: {
     
   }
  });
 
 